import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { Image } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';

const styles = css`
  margin-bottom: 40px;
  img {
    max-width:100%;
    padding:4px;
  }
`;

function PromoBanner({ widget }) {
  return (
    <div className={styles}>
      <div className="container text-center">
        <p>
          {get(widget, 'text')}
          <Image
            src={get(widget, 'image.contentUrl')}
            alt={get(widget, 'image.name')}
            width={235}
          />
        </p>
      </div>
    </div>
  );
}

PromoBanner.propTypes = {
  widget: PropTypes.object.isRequired,
};

export default withData(
  {
    widget: 'payment_types',
  },
)(PromoBanner);



// WEBPACK FOOTER //
// ./src/components/PaymentTypes.js